var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquarePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.5H19.5C21.1406 1.5 22.5 2.85938 22.5 4.5V19.5C22.5 21.1406 21.1406 22.5 19.5 22.5H4.5C2.85938 22.5 1.5 21.1406 1.5 19.5V4.5C1.5 2.85938 2.85938 1.5 4.5 1.5ZM13.125 13.125H16.5C17.1094 13.125 17.625 12.6094 17.625 12C17.625 11.3906 17.1094 10.875 16.5 10.875H13.125V7.5C13.125 6.89062 12.6094 6.375 12 6.375C11.3906 6.375 10.875 6.89062 10.875 7.5V10.875H7.5C6.89062 10.875 6.375 11.3906 6.375 12C6.375 12.6094 6.89062 13.125 7.5 13.125H10.875V16.5C10.875 17.1094 11.3906 17.625 12 17.625C12.6094 17.625 13.125 17.1094 13.125 16.5V13.125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.125H13.125V16.5C13.125 17.1094 12.6094 17.625 12 17.625C11.3906 17.625 10.875 17.1094 10.875 16.5V13.125H7.5C6.89062 13.125 6.375 12.6094 6.375 12C6.375 11.3906 6.89062 10.875 7.5 10.875H10.875V7.5C10.875 6.89062 11.3906 6.375 12 6.375C12.6094 6.375 13.125 6.89062 13.125 7.5V10.875H16.5C17.1094 10.875 17.625 11.3906 17.625 12C17.625 12.6094 17.1094 13.125 16.5 13.125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePlus);
export default __webpack_public_path__ + "static/media/square-plus.5235cfba8ea1edfe0d9124d503845400.svg";
export { ForwardRef as ReactComponent };